import mime from 'mime';
import { deserializeYesplanAPIDateAndTime } from '../libs/dateTimeUtilities';
import { printInShortDateAndHourFormat } from '../libs/dateTimePrinting';

export default class YPGeneratedReportObject {
  constructor(generatedReportJSON) {
    this.id = generatedReportJSON.id;
    this.templateId = generatedReportJSON.template.id;
    this.name = generatedReportJSON.name;
    this.url = generatedReportJSON.dataurl;
    this.created = deserializeYesplanAPIDateAndTime(generatedReportJSON.created);
    this.description = generatedReportJSON.description;
    this.extension = null;
    if (generatedReportJSON.datatype)
      this.extension = mime.getExtension(generatedReportJSON.datatype);
  }

  isDocument() {
    return true;
  }

  printName() {
    return this.name;
  }

  printDescription() {
    return this.description;
  }

  printCreationDate(dateFormatSetting, timeFormatSetting) {
    return printInShortDateAndHourFormat(
      this.created,
      timeFormatSetting,
      dateFormatSetting,
      true,
      true,
      ', '
    );
  }
}
